import { render } from "./Kode_AI_Button.vue?vue&type=template&id=1875d130&scoped=true"
import script from "./Kode_AI_Button.vue?vue&type=script&lang=js"
export * from "./Kode_AI_Button.vue?vue&type=script&lang=js"

import "./Kode_AI_Button.vue?vue&type=style&index=0&id=1875d130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1875d130"]])

export default __exports__